class Square extends React.Component {
  render () {
    return (
      <li className="section__item">
        <h3 className="section__item-title" id="square">
          Square
          <span className="section__item-docs">
            Documentation: <a href="docs/scss#mixins-mixin-square" target="_blank">SCSS</a>
          </span>
        </h3>
        <div className="section__demo">
         <Collapser>
            <div className="demo">
              <h4 className="demo__title">Square container</h4>
              <div className="demo__code">
                <CodeBlock lang="html">
                {`
<div class="size-demo">
  This is a square
</div>
                `}
                </CodeBlock>
                <CodeBlock lang="scss">
                {`
.square-demo {
  @include square(300px);

  background: $azure;
  margin: 0 auto;
}
                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <div className="square-demo">
                    This is a square
                  </div>
                </Output>
              </div>
            </div>
          </Collapser>
        </div>
      </li>
    );
  }
};
